export const SHOW_INCREMENT_TABLE = '@incrementTable/SHOW_INCREMENT_TABLE';